import { QuizQuestion } from '../types/quiz';

export const quizQuestions: QuizQuestion[] = [
  // PHISHING - Email
  {
    id: 'phishing-1',
    category: 'phishing',
    difficulty: 'easy',
    question:
      'Vous recevez un email de votre "banque" vous demandant de cliquer sur un lien pour "vérifier votre compte". Que faites-vous ?',
    context: "L'email semble provenir de votre banque avec le logo officiel.",
    options: [
      {
        id: 'p1-a',
        text: 'Je clique sur le lien immédiatement pour sécuriser mon compte',
        isCorrect: false,
      },
      {
        id: 'p1-b',
        text: 'Je contacte ma banque directement via leur numéro officiel',
        isCorrect: true,
      },
      {
        id: 'p1-c',
        text: "Je réponds à l'email pour demander des précisions",
        isCorrect: false,
      },
      {
        id: 'p1-d',
        text: "Je transfère l'email à mes contacts pour les avertir",
        isCorrect: false,
      },
    ],
    explanation:
      "Les banques ne demandent JAMAIS de vérifier vos informations par email. C'est un classique du phishing !",
    tips: [
      "Vérifiez toujours l'adresse email de l'expéditeur",
      'Contactez votre banque par téléphone en utilisant le numéro officiel',
      'Ne cliquez jamais sur des liens suspects',
      'Méfiez-vous des demandes urgentes',
    ],
    mockWebsite: {
      type: 'email',
      content: {
        from: 'securite@banque-populalre.com',
        subject: '🔒 Action Urgente Requise - Vérification de Compte',
        body: 'Cher(e) client(e),\n\nNous avons détecté une activité inhabituelle sur votre compte bancaire.\n\nPour des raisons de sécurité, nous vous demandons de vérifier vos informations personnelles dans les 24 heures.\n\nSi vous ne le faites pas, votre compte sera temporairement suspendu.',
        buttons: [{ text: '🔐 VÉRIFIER MON COMPTE MAINTENANT', style: 'bg-blue-600' }],
      },
      redFlags: [
        'Faute dans le domaine: "populalre" au lieu de "populaire"',
        'Ton alarmiste et urgent',
        'Menace de suspension de compte',
        'Demande de cliquer sur un lien',
        'Les vraies banques ne font jamais ça par email',
      ],
    },
  },
  {
    id: 'phishing-2',
    category: 'phishing',
    difficulty: 'medium',
    question: 'Comment reconnaître une adresse email de phishing ?',
    options: [
      {
        id: 'p2-a',
        text: "Elle contient toujours des fautes d'orthographe",
        isCorrect: false,
      },
      {
        id: 'p2-b',
        text: "Elle peut ressembler à l'originale avec de légères variations (ex: arnaz0n.com au lieu d'amazon.com)",
        isCorrect: true,
      },
      {
        id: 'p2-c',
        text: 'Elle est toujours en majuscules',
        isCorrect: false,
      },
      {
        id: 'p2-d',
        text: 'Elle contient forcément des chiffres',
        isCorrect: false,
      },
    ],
    explanation:
      'Les fraudeurs utilisent des domaines très similaires aux vrais (typosquatting) pour tromper les victimes.',
    tips: [
      'Vérifiez attentivement le nom de domaine',
      'Attention aux caractères remplacés (0 au lieu de O, etc.)',
      "Survolez les liens sans cliquer pour voir l'URL réelle",
      'Utilisez un gestionnaire de mots de passe qui détecte les faux sites',
    ],
    mockWebsite: {
      type: 'email',
      content: {
        from: 'livraison@amaz0n-france.com',
        subject: '📦 Votre commande #FR-8492749 nécessite une action',
        body: "Bonjour,\n\nVotre colis ne peut être livré car l'adresse est incomplète.\n\nMerci de mettre à jour vos informations de livraison en cliquant sur le bouton ci-dessous.\n\nVotre colis sera retourné dans 48h si aucune action n'est effectuée.",
        buttons: [{ text: '📍 METTRE À JOUR MON ADRESSE', style: 'bg-orange-600' }],
      },
      redFlags: [
        'Domaine frauduleux: "amaz0n" avec un zéro au lieu de "amazon"',
        'Amazon utilise @amazon.fr, jamais @amaz0n-france.com',
        'Urgence artificielle (48h)',
        'Demande de mise à jour via email suspect',
        'Vérifiez toujours dans votre compte Amazon officiel',
      ],
    },
  },

  // SMS - Smishing
  {
    id: 'sms-1',
    category: 'sms',
    difficulty: 'easy',
    question:
      'Vous recevez un SMS : "Votre colis est bloqué. Payez 2€ via ce lien pour le débloquer". Que faites-vous ?',
    context: "Le SMS semble provenir d'un service de livraison connu.",
    options: [
      {
        id: 's1-a',
        text: 'Je paie rapidement pour recevoir mon colis',
        isCorrect: false,
      },
      {
        id: 's1-b',
        text: 'Je vérifie sur le site officiel du transporteur ou mon application de suivi',
        isCorrect: true,
      },
      {
        id: 's1-c',
        text: "Je réponds au SMS pour demander plus d'informations",
        isCorrect: false,
      },
      {
        id: 's1-d',
        text: "Je clique sur le lien pour voir de quoi il s'agit",
        isCorrect: false,
      },
    ],
    explanation:
      'C\'est une arnaque très courante appelée "smishing". Les vrais transporteurs ne demandent jamais de payer par SMS.',
    tips: [
      "Les transporteurs légitimes n'envoient pas de liens de paiement par SMS",
      "Vérifiez toujours via l'application officielle",
      'Ne cliquez jamais sur les liens dans les SMS suspects',
      'Méfiez-vous des montants faibles (1-3€) qui visent à voler vos données bancaires',
    ],
    mockWebsite: {
      type: 'sms',
      content: {
        iframeUrl: '/fake_iphone_sms_scam.html',
        sender: 'ChronoPost',
        message:
          "📦 Votre colis est en attente.\n\nFrais de livraison impayés: 2,99€\n\nRéglez maintenant:\nhttps://chronopost-fr.xyz/colis/track/ZE8492\n\n⚠️ Vous avez 48h avant retour à l'expéditeur",
        urgency: '⏰ Délai de 48h avant retour du colis',
      },
      redFlags: [
        'URL suspecte: .xyz au lieu de .fr',
        'Demande de paiement par SMS',
        'Montant faible pour voler vos données bancaires',
        'Pression temporelle',
        'Les vrais transporteurs utilisent leurs apps officielles',
      ],
    },
  },
  {
    id: 'sms-2',
    category: 'sms',
    difficulty: 'medium',
    question:
      'SMS reçu : "Amende impayée - Votre permis sera suspendu. Régularisez sur amende-gouv.fr". Comment vérifier ?',
    options: [
      {
        id: 's2-a',
        text: "Je clique sur le lien, il a l'air officiel",
        isCorrect: false,
      },
      {
        id: 's2-b',
        text: "Je tape moi-même l'adresse officielle (antai.gouv.fr) dans mon navigateur",
        isCorrect: true,
      },
      {
        id: 's2-c',
        text: 'Je sauvegarde le numéro comme "Gouvernement"',
        isCorrect: false,
      },
      {
        id: 's2-d',
        text: 'Je paie vite pour éviter la suspension',
        isCorrect: false,
      },
    ],
    explanation:
      'Le vrai site des amendes est antai.gouv.fr, pas "amende-gouv.fr". Toujours taper soi-même les URLs officielles.',
    tips: [
      'Les sites gouvernementaux français se terminent en .gouv.fr',
      'Ne jamais cliquer sur les liens dans les SMS officiels',
      "Taper soi-même l'adresse du site dans le navigateur",
      "Vérifier l'orthographe exacte des noms de domaine",
    ],
    mockWebsite: {
      type: 'sms',
      content: {
        sender: 'GOUVERNEMENT',
        message:
          '⚠️ AMENDE IMPAYÉE\n\nVotre amende n°FR89274 reste impayée.\n\nRisque de suspension du permis de conduire.\n\nRégularisez maintenant sur:\nhttps://amende-gouv.fr/paiement/FR89274\n\nDernière chance: 72h',
        urgency: '⏰ 72h avant suspension du permis',
      },
      redFlags: [
        'Faux domaine: "amende-gouv.fr" au lieu de "antai.gouv.fr"',
        'Le vrai site est antai.gouv.fr (ANTAI)',
        'Menace de suspension pour créer la panique',
        'Les vraies amendes arrivent par courrier postal',
        'Jamais de lien de paiement par SMS',
      ],
    },
  },

  // PHONE - Vishing
  {
    id: 'phone-1',
    category: 'phone',
    difficulty: 'easy',
    question:
      'Un "conseiller bancaire" vous appelle et demande votre code de carte bancaire pour "sécuriser votre compte". Que faites-vous ?',
    options: [
      {
        id: 'ph1-a',
        text: "Je donne le code, c'est ma banque qui appelle",
        isCorrect: false,
      },
      {
        id: 'ph1-b',
        text: 'Je raccroche et rappelle ma banque au numéro officiel',
        isCorrect: true,
      },
      {
        id: 'ph1-c',
        text: 'Je donne seulement les 3 premiers chiffres pour vérifier',
        isCorrect: false,
      },
      {
        id: 'ph1-d',
        text: "Je demande d'abord son nom et son service",
        isCorrect: false,
      },
    ],
    explanation:
      "AUCUNE banque ne demandera JAMAIS vos codes confidentiels par téléphone. C'est une arnaque à 100% !",
    tips: [
      'Ne JAMAIS donner vos codes par téléphone',
      'Raccrochez immédiatement',
      'Rappelez votre banque via le numéro officiel',
      'Les banques connaissent déjà vos informations',
    ],
    mockWebsite: {
      type: 'popup',
      content: {
        title: '☎️ APPEL EN COURS',
        description:
          '📞 Banque Populaire - Service Sécurité\n\n"Bonjour, je suis Thomas Durand du service anti-fraude.\n\nNous avons détecté 3 transactions suspectes sur votre compte ce matin.\n\nPour sécuriser votre compte, j\'ai besoin de vérifier votre identité avec votre code de carte bancaire."',
        urgency: '🚨 L\'appelant insiste: "C\'est urgent, votre argent est en danger !"',
        buttons: [
          { text: '❌ RACCROCHER IMMÉDIATEMENT', style: 'bg-green-600' },
          { text: '⚠️ Donner le code (PIÈGE!)', style: 'bg-red-600' },
        ],
      },
      redFlags: [
        'Aucune banque ne demande de codes par téléphone',
        'Pression et urgence pour vous faire paniquer',
        'Les banques vous connaissent déjà',
        'Technique du faux agent très poli et professionnel',
        'Raccrochez et rappelez le numéro officiel',
      ],
    },
  },
  {
    id: 'phone-2',
    category: 'phone',
    difficulty: 'hard',
    question:
      'Appel d\'un "policier" disant qu\'une fraude a été détectée sur votre compte. Il demande de transférer votre argent sur un "compte sécurisé". Que faites-vous ?',
    context: "L'appelant connaît votre nom et semble professionnel.",
    options: [
      {
        id: 'ph2-a',
        text: "Je fais le transfert, c'est la police",
        isCorrect: false,
      },
      {
        id: 'ph2-b',
        text: 'Je raccroche et contacte le commissariat local',
        isCorrect: true,
      },
      {
        id: 'ph2-c',
        text: "Je demande à voir sa carte de police d'abord",
        isCorrect: false,
      },
      {
        id: 'ph2-d',
        text: 'Je transfère une petite somme pour tester',
        isCorrect: false,
      },
    ],
    explanation:
      "La police n'appelle JAMAIS pour demander de transférer de l'argent. C'est une arnaque sophistiquée très dangereuse.",
    tips: [
      'La police ne gère pas les comptes bancaires',
      "Aucune autorité ne demandera de transférer de l'argent",
      'En cas de doute, contactez le commissariat',
      'Les fraudeurs peuvent falsifier les numéros affichés (spoofing)',
    ],
    mockWebsite: {
      type: 'popup',
      content: {
        title: '👮 APPEL - POLICE NATIONALE',
        description:
          '📞 Affichage: "POLICE - 17"\n\n"Bonjour, Lieutenant Moreau de la Brigade Financière.\n\nVotre compte bancaire est actuellement utilisé pour du blanchiment d\'argent.\n\nPour protéger vos fonds, vous devez IMMÉDIATEMENT les transférer sur notre compte sécurisé le temps de l\'enquête.\n\nSi vous refusez, votre compte sera saisi dans l\'heure."',
        urgency: '⚠️ Numéro affiché falsifié par spoofing',
        buttons: [
          { text: '✅ RACCROCHER et appeler le 17', style: 'bg-green-600' },
          { text: '🚫 Faire le transfert (ARNAQUE!)', style: 'bg-red-600' },
        ],
      },
      redFlags: [
        "La police ne demande JAMAIS de transférer de l'argent",
        'Spoofing: le numéro affiché peut être falsifié',
        'Menace de saisie pour vous faire paniquer',
        'La police travaille avec votre banque, pas avec vous',
        'Contactez le commissariat pour vérifier',
      ],
    },
  },

  // WEBSITE - Faux sites
  {
    id: 'web-1',
    category: 'website',
    difficulty: 'medium',
    question:
      'Vous cherchez à acheter un iPhone neuf à 300€ sur un site inconnu. Quels signes doivent vous alerter ?',
    options: [
      {
        id: 'w1-a',
        text: "Le prix très bas, c'est forcément une arnaque",
        isCorrect: false,
      },
      {
        id: 'w1-b',
        text: 'Absence de mentions légales, paiement uniquement par virement, prix trop bas',
        isCorrect: true,
      },
      {
        id: 'w1-c',
        text: "Le site a un design moderne, donc c'est sûr",
        isCorrect: false,
      },
      {
        id: 'w1-d',
        text: "Il y a un cadenas (HTTPS), donc c'est fiable",
        isCorrect: false,
      },
    ],
    explanation:
      'Le HTTPS ne garantit PAS la fiabilité ! Un site frauduleux peut avoir HTTPS. Vérifiez toujours mentions légales, avis, et moyens de paiement.',
    tips: [
      "Un cadenas HTTPS n'indique pas que le site est légitime",
      'Vérifiez les mentions légales et CGV',
      'Cherchez des avis externes (Trustpilot, Google)',
      'Méfiez-vous des prix trop beaux pour être vrais',
      'Privilégiez les paiements sécurisés (CB, PayPal)',
      'Évitez les virements bancaires pour des inconnus',
    ],
    mockWebsite: {
      type: 'ecommerce',
      siteName: 'iPhonePasCher',
      url: 'iphonepromo-fr.xyz',
      content: {
        title: '🔥 iPhone 15 Pro Max - Neuf avec Garantie',
        price: '299€',
        description:
          'iPhone 15 Pro Max 256Go, couleur Titane Bleu. 100% Neuf, jamais déballé. Garantie constructeur incluse. Stock limité !',
        urgency: '⏰ OFFRE LIMITÉE - Plus que 3 en stock ! Commandez maintenant !',
        badges: ['✓ Livraison Gratuite', '✓ Garantie 2 ans', '✓ 100% Neuf'],
        buttons: [
          { text: '🛒 ACHETER MAINTENANT', style: 'bg-orange-600' },
          { text: '💳 Payer par virement bancaire', style: 'bg-green-600' },
        ],
        images: ['📱'],
      },
      redFlags: [
        'URL suspecte (.xyz au lieu de .fr ou .com)',
        'Prix 70% moins cher que le marché',
        'Paiement par virement demandé',
        'Urgence artificielle pour presser',
        'Pas de mentions légales visibles',
      ],
    },
  },
  {
    id: 'web-2',
    category: 'website',
    difficulty: 'hard',
    question: "Sur quel élément NE faut-il PAS se fier pour juger de la fiabilité d'un site ?",
    options: [
      {
        id: 'w2-a',
        text: "La présence d'avis clients sur le site lui-même",
        isCorrect: true,
      },
      {
        id: 'w2-b',
        text: 'Les mentions légales complètes avec SIRET',
        isCorrect: false,
      },
      {
        id: 'w2-c',
        text: 'Les avis sur des plateformes tierces vérifiées',
        isCorrect: false,
      },
      {
        id: 'w2-d',
        text: 'La possibilité de contacter le service client par plusieurs moyens',
        isCorrect: false,
      },
    ],
    explanation:
      'Les avis directement sur le site peuvent être facilement falsifiés. Cherchez toujours des avis sur des plateformes externes indépendantes.',
    tips: [
      'Les avis sur le site peuvent être inventés',
      'Consultez Google Reviews, Trustpilot, ou autres plateformes',
      'Vérifiez le numéro SIRET sur societe.com',
      'Testez les coordonnées de contact',
      'Cherchez le nom du site + "arnaque" sur Google',
    ],
    mockWebsite: {
      type: 'ecommerce',
      siteName: 'TechPasCher',
      url: 'tech-pas-cher.shop',
      content: {
        title: '💻 MacBook Pro M3 - Prix Cassé',
        price: '599€',
        description: 'MacBook Pro M3 16" neuf scellé. Garantie Apple 1 an. Livraison express 48h.',
        urgency: '🔥 Dernière pièce en stock !',
        badges: ['⭐ 5/5 (892 avis)', '✓ Site Sécurisé', '✓ Satisfait ou Remboursé'],
        buttons: [{ text: '🛒 COMMANDER MAINTENANT', style: 'bg-blue-600' }],
        images: ['💻'],
      },
      redFlags: [
        'Avis directement sur le site = facilement falsifiés',
        'Aucune trace sur Google, Trustpilot, etc.',
        'Prix irréaliste (MacBook Pro = 2500€ minimum)',
        'Domaine récent (.shop suspect)',
        'Pas de SIRET visible dans mentions légales',
        'Vérifiez TOUJOURS les avis externes',
      ],
    },
  },

  // SOCIAL MEDIA - Réseaux sociaux
  {
    id: 'social-1',
    category: 'social',
    difficulty: 'easy',
    question:
      'Sur Facebook, un "ami" que vous ne connaissez pas bien vous envoie un message urgent demandant de l\'argent. Que faites-vous ?',
    context:
      'Le message dit : "SOS ! Mon compte a été piraté, peux-tu m\'envoyer 50€ ? Je te rembourse demain."',
    options: [
      {
        id: 'so1-a',
        text: "J'envoie l'argent, c'est un ami en détresse",
        isCorrect: false,
      },
      {
        id: 'so1-b',
        text: 'Je contacte la personne par un autre moyen (téléphone, autre réseau) pour vérifier',
        isCorrect: true,
      },
      {
        id: 'so1-c',
        text: 'Je demande plus de détails par message',
        isCorrect: false,
      },
      {
        id: 'so1-d',
        text: "J'envoie 20€ au lieu de 50€ par précaution",
        isCorrect: false,
      },
    ],
    explanation:
      "Le compte de votre ami a probablement été piraté. Vérifiez toujours par un autre canal (téléphone) avant d'envoyer de l'argent.",
    tips: [
      'Les comptes piratés sont utilisés pour arnaquer les contacts',
      'Vérifiez toujours par téléphone ou en personne',
      "Méfiez-vous des demandes d'argent urgentes",
      'Signalez le compte compromis au réseau social',
    ],
    mockWebsite: {
      type: 'social',
      content: {
        from: 'Sophie Martin',
        message:
          "SOS 🆘🆘🆘\n\nC'est ultra urgent !!! Mon compte bancaire a été bloqué et j'ai besoin de 50€ pour payer mes courses aujourd'hui.\n\nJe suis vraiment dans la galère, tu peux m'aider ?\n\nJe te rembourse demain promis 🙏\n\nEnvoie sur mon PayPal: sophie.m.urgent@gmail.com",
        urgency: '⚠️ Message envoyé depuis un compte possiblement compromis',
      },
      redFlags: [
        "Demande d'argent urgente et inhabituelle",
        "Utilisation excessive d'émojis et de majuscules",
        'Email PayPal suspect (pas le vrai compte)',
        'Pression émotionnelle ("galère", "urgent")',
        'Promesse de remboursement rapide',
        'Le vrai ami vous appellerait probablement',
      ],
    },
  },
  {
    id: 'social-2',
    category: 'social',
    difficulty: 'medium',
    question:
      'Vous voyez une publicité Instagram : "Gagnez un iPhone en participant à notre sondage". Qu\'est-ce qui devrait vous alerter ?',
    options: [
      {
        id: 'so2-a',
        text: 'Rien, les concours sur Instagram sont légaux',
        isCorrect: false,
      },
      {
        id: 'so2-b',
        text: 'On demande vos informations bancaires "pour l\'envoi du cadeau"',
        isCorrect: true,
      },
      {
        id: 'so2-c',
        text: "Le compte a beaucoup d'abonnés",
        isCorrect: false,
      },
      {
        id: 'so2-d',
        text: 'La publicité est en français',
        isCorrect: false,
      },
    ],
    explanation:
      "Un vrai concours ne demandera JAMAIS vos coordonnées bancaires. C'est un prétexte pour voler vos données.",
    tips: [
      'Jamais de CB pour recevoir un "cadeau gratuit"',
      'Vérifiez que le compte est certifié (badge bleu)',
      'Cherchez des avis sur le concours',
      'Lisez le règlement du jeu-concours',
      'Méfiez-vous des offres trop belles',
    ],
    mockWebsite: {
      type: 'social',
      content: {
        from: 'iPhone_Gratuit_France',
        message:
          '🎉🎉 CONCOURS EXCEPTIONNEL 🎉🎉\n\n🎁 GAGNEZ UN iPHONE 15 PRO MAX GRATUIT ! 🎁\n\nPour participer:\n✅ Suivez notre compte\n✅ Likez ce post\n✅ Répondez au sondage (2 min)\n✅ Payez 1€ de frais de port\n\n⏰ TIRAGE DANS 24H ! ⏰\n\n👉 Lien dans la bio',
        urgency: '🚨 12,847 participants - Dépêchez-vous !',
      },
      redFlags: [
        'Demande de paiement pour un cadeau "gratuit"',
        'Compte non certifié (pas de badge bleu)',
        'Nombre de participants gonflé artificiellement',
        'Pas de règlement officiel du concours',
        'Demande de coordonnées bancaires suspecte',
        'Les vrais concours ne demandent JAMAIS de CB',
      ],
    },
  },

  // Questions BONUS - Mixtes et avancées
  {
    id: 'bonus-1',
    category: 'phishing',
    difficulty: 'hard',
    question:
      'Quelle technique les escrocs utilisent-ils pour que leur numéro de téléphone affiche "Votre Banque" sur votre écran ?',
    options: [
      {
        id: 'b1-a',
        text: 'Ils piratent votre téléphone',
        isCorrect: false,
      },
      {
        id: 'b1-b',
        text: 'Le spoofing (usurpation de numéro)',
        isCorrect: true,
      },
      {
        id: 'b1-c',
        text: 'Ils achètent le vrai numéro de la banque',
        isCorrect: false,
      },
      {
        id: 'b1-d',
        text: 'C\'est impossible, si ça affiche "Votre Banque" c\'est réel',
        isCorrect: false,
      },
    ],
    explanation:
      "Le spoofing permet de falsifier le numéro ou le nom affiché. Ne faites JAMAIS confiance à l'affichage seul.",
    tips: [
      "L'affichage du numéro peut être falsifié",
      'Ne vous fiez jamais uniquement au nom affiché',
      'En cas de doute, raccrochez et rappelez',
      'Utilisez toujours les numéros officiels trouvés sur le site web',
    ],
    mockWebsite: {
      type: 'popup',
      content: {
        title: '📱 APPEL ENTRANT',
        description:
          '📞 Affichage sur votre téléphone:\n\n👤 "CRÉDIT AGRICOLE"\n☎️  09 XX XX XX XX\n\n💬 "Bonjour, Service Sécurité du Crédit Agricole..."\n\n⚠️ ATTENTION: Ce numéro et ce nom sont FALSIFIÉS par une technique appelée SPOOFING !\n\nLes escrocs peuvent faire afficher N\'IMPORTE QUEL nom sur votre écran.',
        urgency: '🔴 Technique de spoofing en cours',
        buttons: [{ text: '✅ Raccrocher et rappeler le vrai numéro', style: 'bg-green-600' }],
      },
      redFlags: [
        'Le spoofing permet de falsifier le numéro affiché',
        'N\'importe qui peut faire afficher "Votre Banque"',
        "Ne JAMAIS faire confiance à l'affichage seul",
        'Raccrochez et rappelez le numéro officiel',
        'Vérifiez sur le site web ou votre carte bancaire',
      ],
    },
  },
  {
    id: 'bonus-2',
    category: 'website',
    difficulty: 'medium',
    question:
      'Quel est le MEILLEUR réflexe face à une offre en ligne qui semble trop belle pour être vraie ?',
    options: [
      {
        id: 'b2-a',
        text: "En profiter avant que l'offre expire",
        isCorrect: false,
      },
      {
        id: 'b2-b',
        text: 'Chercher "[nom du site] arnaque" sur Google et vérifier les avis',
        isCorrect: true,
      },
      {
        id: 'b2-c',
        text: "Demander l'avis de mes amis sur les réseaux sociaux",
        isCorrect: false,
      },
      {
        id: 'b2-d',
        text: 'Commander en petite quantité pour tester',
        isCorrect: false,
      },
    ],
    explanation:
      "Toujours faire des recherches avant d'acheter. Les sites frauduleux laissent généralement des traces d'arnaques en ligne.",
    tips: [
      'Recherchez toujours "[nom] arnaque" ou "[nom] avis"',
      "Consultez les plateformes d'avis indépendantes",
      'Vérifiez depuis combien de temps le site existe (Whois)',
      "Si c'est trop beau pour être vrai, c'est probablement faux",
    ],
    mockWebsite: {
      type: 'ecommerce',
      siteName: 'MegaSoldes24',
      url: 'megasoldes-promo.online',
      content: {
        title: '🔥 PlayStation 5 + 2 Manettes + 5 Jeux - NEUF',
        price: '149€',
        description:
          'Console PS5 dernière génération avec 2 manettes DualSense + 5 jeux AAA inclus (FIFA 24, GTA 6, Spider-Man 2...). 100% authentique, garantie constructeur 2 ans !',
        urgency: '⚡ VENTE FLASH - Plus que 47 minutes ! Stock limité à 12 unités !',
        badges: ['✓ Livraison 24h', '✓ Paiement Sécurisé', '✓ -85% !', '⭐ 4.9/5 (2847 avis)'],
        buttons: [
          { text: '🛒 ACHETER MAINTENANT - 149€', style: 'bg-red-600' },
          { text: '💰 Payer par virement (5% de réduction)', style: 'bg-green-600' },
        ],
        images: ['🎮'],
      },
      redFlags: [
        'Prix totalement irréaliste (PS5 seule = 550€ minimum)',
        'Domaine suspect (.online au lieu de .fr)',
        'Urgence artificielle (compte à rebours)',
        'Avis probablement faux (trop parfait)',
        'Demande de paiement par virement',
        'Créé récemment (vérifiable via Whois)',
      ],
    },
  },
  {
    id: 'support-1',
    category: 'support',
    difficulty: 'medium',
    question:
      'Vous recevez un appel ou un pop-up disant que votre ordinateur est infecté et qu’il faut appeler un “support technique” pour réparer. Que faire ?',
    context:
      'Le message ou l’appel semble provenir de Microsoft ou d’un grand éditeur, avec des logos officiels.',
    options: [
      {
        id: 'sup1-a',
        text: 'J’appelle le numéro et je paie pour la réparation',
        isCorrect: false,
      },
      {
        id: 'sup1-b',
        text: 'Je ferme le pop-up et vérifie l’état de mon ordinateur avec un antivirus officiel',
        isCorrect: true,
      },
      {
        id: 'sup1-c',
        text: 'Je donne l’accès à distance à mon ordinateur au “technicien”',
        isCorrect: false,
      },
      {
        id: 'sup1-d',
        text: 'Je partage le numéro avec mes amis pour les aider',
        isCorrect: false,
      },
    ],
    explanation:
      'Aucun vrai support technique ne contacte spontanément les utilisateurs. Les pop-ups ou appels alarmants sont des arnaques pour voler vos données ou votre argent.',
    tips: [
      'Ne jamais appeler les numéros affichés dans des pop-ups ou emails alarmants',
      'Utilisez uniquement des logiciels de sécurité officiels',
      "Ne donnez jamais l'accès à distance à un inconnu",
      'Fermez la fenêtre et analysez votre ordinateur avec un antivirus reconnu',
    ],
    mockWebsite: {
      type: 'popup',
      content: {},
      redFlags: [
        'Pop-up impossible à fermer facilement',
        'Messages alarmistes et urgents',
        'Microsoft ne fait jamais ce genre de pop-up',
        'Numéro de téléphone affiché (arnaque au support)',
        'Demande de télécharger ou appeler',
        'Compte à rebours pour créer la panique',
        "Fausse URL Microsoft dans la barre d'adresse",
        'Bloque les fonctions du navigateur (F12, clic droit)',
      ],
    },
  },
];

export const categoryInfo = {
  phishing: {
    name: 'Phishing Email',
    description: 'Emails frauduleux imitant des organismes officiels',
    icon: '📧',
    color: 'from-blue-500 to-blue-600',
  },
  sms: {
    name: 'Smishing',
    description: 'Arnaques par SMS (faux colis, amendes...)',
    icon: '📱',
    color: 'from-green-500 to-green-600',
  },
  phone: {
    name: 'Vishing',
    description: 'Appels téléphoniques frauduleux',
    icon: '📞',
    color: 'from-purple-500 to-purple-600',
  },
  website: {
    name: 'Faux Sites',
    description: 'Sites web frauduleux et contrefaçons',
    icon: '🌐',
    color: 'from-orange-500 to-orange-600',
  },
  social: {
    name: 'Réseaux Sociaux',
    description: 'Arnaques sur Facebook, Instagram, etc.',
    icon: '👥',
    color: 'from-pink-500 to-pink-600',
  },
  support: {
    name: 'Faux Support Technique',
    description: 'Arnaques par faux support technique ou pop-up alarmant',
    icon: '🛠️',
    color: 'from-gray-500 to-gray-600',
  },
};
